import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppRouteNames } from '../../app.routing.names';
import { HomeRouteNames } from '../../modules/home/home.routing.names';

export const pseudoAuthGuard: CanActivateFn = () => {
  const router = inject(Router);
  const loggedIn = localStorage.getItem('pseudoLogin') === 'true';
  if (!loggedIn) {
    return router.parseUrl(`${AppRouteNames.HOME}/${HomeRouteNames.PSEUDO_LOGIN}`);
  }
  return true;
};
